import { Box, Flex, Image, Tooltip } from "@chakra-ui/react";
import androidImage from "assets/img/platform/android-alt.png";
import iosImage from "assets/img/platform/ios.png";
import { OptimizeGame } from "../data";

const initials = (name: string) =>
  name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const GameAvatar: React.FC<{
  game: OptimizeGame;
  size?: number;
  showPlatform?: boolean;
}> = ({ game, size = 44, showPlatform = true }) => {
  // the same store badges as the main games list (default/ComplexTable), at
  // its ratio: an 18px badge on a 40px icon, overhanging the corner by 3px
  const badgeSize = Math.round(size * 0.45);
  const overhang = Math.round(size * 0.075);

  return (
    <Tooltip label={`${game.name} (${game.platform})`} placement="top">
      <Box position="relative" flexShrink={0}>
        <Flex
          w={`${size}px`}
          h={`${size}px`}
          borderRadius="14px"
          background={game.gradient}
          align="center"
          justify="center"
          color="white"
          fontWeight="bold"
          fontSize={`${Math.round(size * 0.36)}px`}
          boxShadow="0 4px 10px rgba(0,0,0,0.12)"
          overflow="hidden"
        >
          {game.icon ? (
            <Image
              src={game.icon}
              alt={game.name}
              w="100%"
              h="100%"
              objectFit="cover"
              fallback={<Box as="span">{initials(game.name)}</Box>}
            />
          ) : (
            initials(game.name)
          )}
        </Flex>
        {showPlatform && (
          <Image
            src={game.platform === "iOS" ? iosImage : androidImage}
            alt={game.platform}
            position="absolute"
            bottom={`-${overhang}px`}
            right={`-${overhang}px`}
            w={`${badgeSize}px`}
            h={`${badgeSize}px`}
            borderRadius={`${Math.max(2, Math.round(badgeSize * 0.22))}px`}
            filter="drop-shadow(0.6px 0.6px 0.6px grey)"
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default GameAvatar;
